/* "Lieferung vor Weihnachten" widget: keeps the day count, the capacity and the last-day clock
   right in the browser (pages are cached, so the server-rendered values can be hours old). */
(function () {
  var MINUTE = 60000;

  // strings come from the snippet's data-i18n (locale keys black_weeks.xmas_*); German if it is missing
  var DE = {
    days: "Noch %n Tage", hours: "%h Std %m Min", clock: "noch %n T %h H %m M %s S",
    a: "Noch %pct % Lieferkapazität vor Weihnachten verfügbar", b: "Nur noch %pct % Lieferkapazität vor Weihnachten verfügbar",
    c: "Nur noch %pct % Lieferkapazität vor Weihnachten – fast ausgebucht",
    lastTitle: "Letzter Tag für die Lieferung vor Weihnachten", lastText: "Bestelle heute bis 23:59 Uhr.**"
  };
  function say(el, key, vals) {
    if (!el._i18n) {
      try { el._i18n = JSON.parse(el.getAttribute("data-i18n") || "{}"); } catch (e) { el._i18n = {}; }
    }
    var str = el._i18n[key] || DE[key];
    // placeholders are %n %h %m %s %pct (a "}" inside a Liquid output tag would end the tag early)
    for (var k in vals) str = str.split("%" + k).join(vals[k]);
    return str;
  }

  function tier(pct) {
    return pct > 50 ? "a" : pct > 20 ? "b" : "c";
  }

  function update(el) {
    var deadline = parseInt(el.getAttribute("data-deadline"), 10) * 1000;
    var showDays = parseInt(el.getAttribute("data-show-days"), 10) || 12;
    var table = (el.getAttribute("data-capacity") || "").split(",").map(function (v) {
      return parseInt(v, 10) || 0;
    });
    if (el.hasAttribute("data-preview")) return; // reviewed with a faked day count: leave the server render
    var left = deadline - Date.now();
    if (left <= 0) {
      el.hidden = true;
      return;
    }
    var daysLeft = Math.ceil(left / 86400000);
    if (daysLeft > showDays) {
      el.hidden = true;
      return;
    }
    el.hidden = false;

    // list read from the deadline backwards: last figure = last day; earlier days keep the first figure
    var pct = table[Math.max(0, table.length - daysLeft)];
    var t = tier(pct);
    el.classList.remove("kc-xmas--a", "kc-xmas--b", "kc-xmas--c");
    el.classList.add("kc-xmas--" + t);

    var pill = el.querySelector("[data-kc-xmas-pill]");
    if (pill) {
      if (daysLeft <= 1) {
        var hours = Math.floor(left / 3600000);
        var minutes = Math.floor((left % 3600000) / MINUTE);
        pill.textContent = say(el, "hours", { h: hours, m: minutes });
      } else {
        pill.textContent = say(el, "days", { n: daysLeft });
      }
    }
    var fill = el.querySelector("[data-kc-xmas-fill]");
    if (fill) fill.style.width = pct + "%";
    var note = el.querySelector("[data-kc-xmas-note]");
    if (note) {
      note.textContent = say(el, t, { pct: pct });
    }
    if (daysLeft <= 1) {
      var title = el.querySelector(".kc-xmas__title");
      if (title && !title.dataset.lastDay) {
        title.dataset.lastDay = "1";
        title.textContent = say(el, "lastTitle");
        var text = el.querySelector(".kc-xmas__text");
        if (text) text.textContent = say(el, "lastText");
      }
    }
  }

  function all() {
    document.querySelectorAll("[data-kc-xmas]").forEach(update);
  }

  // compact look: the pill counts down to the deadline, to the second ("noch 32 T 10 H 22 M 52 S");
  // data-clock on the pill marks that it shows the clock, whatever the language
  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function countdown() {
    var desktop = window.matchMedia("(min-width: 700px)").matches;
    document.querySelectorAll("[data-kc-xmas-countdown]").forEach(function (el) {
      var pill = el.querySelector("[data-kc-xmas-pill]");
      var left = parseInt(el.getAttribute("data-deadline"), 10) * 1000 - Date.now();
      if (!pill || left <= 0) return;
      if (!desktop) {
        // phones keep "Noch X Tage" (also after the window was narrowed from a counting desktop)
        if (pill.hasAttribute("data-clock")) {
          var days = parseInt(el.getAttribute("data-preview"), 10) || Math.ceil(left / 86400000);
          pill.textContent = say(el, "days", { n: days });
          pill.removeAttribute("data-clock");
        }
        return;
      }
      var d = Math.floor(left / 86400000);
      var rest = left - d * 86400000;
      var h = Math.floor(rest / 3600000), m = Math.floor((rest % 3600000) / 60000), s = Math.floor((rest % 60000) / 1000);
      pill.textContent = say(el, "clock", { n: d, h: pad(h), m: pad(m), s: pad(s) });
      pill.setAttribute("data-clock", "");
    });
  }
  countdown();
  setInterval(countdown, 1000);

  // the info button on the light card: toggles its popover; a click elsewhere closes it. Bound on the
  // buttons themselves: the product page stops clicks before they reach the document.
  function bindInfo() {
    document.querySelectorAll("[data-kc-xmas-info]").forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "1";
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        var pop = btn.parentNode.querySelector("[data-kc-xmas-pop]");
        var open = pop.hidden;
        pop.hidden = !open;
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-kc-xmas-pop]")) return;
    document.querySelectorAll("[data-kc-xmas-pop]").forEach(function (pop) { pop.hidden = true; });
    document.querySelectorAll("[data-kc-xmas-info]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
  });
  bindInfo();
  new MutationObserver(bindInfo).observe(document.documentElement, { childList: true, subtree: true });

  all();
  setInterval(all, MINUTE);
  document.addEventListener("shopify:section:load", all);
})();
